export default "__VITE_ASSET__BbI$0fJL__"